<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Update Details"
              bc1="App"
              bc2="Terminal"
              bc3="Update"
              path="terminal"
          ></Breadcrumb>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Update Details</h4>
                </div>
                <div class="card-body">
                  <ValidationObserver
                      ref="observer"
                      tag="form"
                      v-slot="{ invalid, validate }"
                  >
                    <form
                        class="form form-horizontal"
                        @submit.prevent="validate().then(sendCall)"
                    >
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label for="name-icon">Name</label>
                            </div>
                            <div class="col-sm-9">
                              <ValidationProvider
                                  name="Name"
                                  ref="name"
                                  rules="required"
                                  v-slot="{ errors }"
                              >
                                <div class="input-group">

                                  <input
                                      type="text"
                                      v-model="name"
                                      id="name-icon"
                                      class="form-control"
                                      :class="errors[0] ? 'is-invalid' : ''"
                                      name="name"
                                      placeholder="Name"
                                      v-validate="'required'"
                                  />
                                </div>
                                <small
                                    class="block text-red-600 text-xs absolute bottom-0 left-0"
                                    style="color:#EA5455"
                                >{{ errors[0] }}</small
                                >
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 d-flex mt-5">
                          <button
                              type="submit"
                              class="btn btn-primary mr-1 d-flex"
                              :disabled="loading"
                          >
                            <Loader :loading="loading" :size="size"></Loader>
                            Submit
                          </button>
                          <button
                              type="button"
                              class="btn btn-gradient-secondary"
                              @click="$router.back()"
                          >
                            Back
                          </button>
                        </div>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    CommandIcon,
    ValidationObserver,
    ValidationProvider
  },
  mounted() {
    this.storeId = this.$route.params.storeId
    var merchantTerminalUpdate = this.$store.getters.getByKey(
        "merchantTerminalUpdate"
    );
    this.terminalId =  merchantTerminalUpdate.row.id
    this.name =  merchantTerminalUpdate.row.name
    this.index = merchantTerminalUpdate.index;
    this.id = merchantTerminalUpdate.row.id;
  },
  data() {
    return {
      name: "",
      loading: false,
      size: "10px",
      storeId:'',
      terminalId:'',
      id: "",
      index: "",


    };
  },

  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            name: this.name,
            storeId: this.storeId,
            terminalId: this.terminalId,

          }
          this.makeRequest("post", "v1/update-terminal", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {
                    this.loading = false;
                    if (callResponse.response.data.data) {
                      let responseData = callResponse.response.data.data;
                      let storeData = this.$store.getters.getByKey(
                          "merchantTerminalList"
                      );
                      if (storeData != null) {
                        if (typeof storeData.firstPageData != "undefined") {
                          if (
                              typeof storeData.firstPageData.data[this.index] !=
                              "undefined"
                          ) {
                            if (
                                storeData.firstPageData.data[this.index].id ==
                                this.id
                            ) {
                              storeData.firstPageData.data[
                                  this.index
                                  ] = responseData;
                              delete storeData.otherPageData;
                            }
                          }
                        }
                        if (typeof storeData.otherPageData != "undefined") {
                          if (
                              typeof storeData.otherPageData.data[this.index] !=
                              "undefined"
                          ) {
                            if (
                                storeData.otherPageData.data[this.index].id ==
                                this.id
                            ) {
                              storeData.otherPageData.data[
                                  this.index
                                  ] = responseData;
                            }
                          }
                        }
                        storeData.key = "merchantTerminalList";
                        this.$store.dispatch("set", storeData);
                      }
                      this.$router.push({
                        name: "terminal",
                        params: {update: true}
                      });
                    }
                  } else {
                    this.loading = false;
                  }
                }
              }

          );
        }
      });
    }
  }
};
</script>

